const favourite_holiday  = `One of the favorite holidays in Finland is Christmas. 
It's a special time when families and friends come together to celebrate and spend time with each other.
During Christmas, people decorate their homes with lights, trees, and ornaments. 
They also exchange gifts with each other and enjoy delicious food, like ham, fish, and gingerbread cookies.
Families often visit the sauna together and enjoy the warmth during the cold winter days.
Some people also go to church to celebrate the holiday and remember its meaning.
One of the special things about Christmas in Finland is the tradition of Santa Claus, 
who is believed to bring gifts to children on Christmas Eve. 
Many families leave a bowl of porridge for Santa Claus to enjoy when he visits their homes.
Overall, Christmas is a joyful and festive time in Finland, filled with love, warmth, and togetherness. 
It's a time when people come together to share happiness and create lasting memories with their loved ones.`;

export default favourite_holiday;